module.exports = __webpack_public_path__ + "static/media/img_background.b027f424.webp";